import { gql } from "@apollo/client";

export const GET_PRODUCTS_OPTION = gql`
  query searchproducts($name: String!) {
    searchProducts(name: $name) {
      associations
      uuid
      values
    }
  }
`;

export const GET_PRODUCT_WITH_PRICEBOOK = gql`
  query SearchProductsWithPriceBook(
    $name: String
    $pageNumber: Int
    $limit: Int
  ) {
    searchProductsWithPriceBook(
      name: $name
      page_number: $pageNumber
      limit: $limit
    ) {
      total_count
      items {
        id
        quantity_per_ctn
        thumbnail_url
        akeneo_token
        mrp
        name
        status {
          name
        }
      }
    }
  }
`;

export const GET_ORDER_STATUS = gql`
query SaleOrderHeaderInfo($id: String!) {
  saleOrderHeaderInfo(_id: $id) {
    _id
    status
  }
}
`;
